import {SiteTargetType} from "@/enums/type";
import {DebtEmployeeStatus} from "@/enums/status";

export class ReceiptPartnerParams {
    page = 1;
    limit = 10;
    targetRowGuid?: string;
    targetType = SiteTargetType.Partner;
    status = DebtEmployeeStatus.NotYetCollect;
    revenueExpenditureId?: number;
}
